import React, { useState, useEffect } from 'react'
import './nav.css'
import { AiOutlineHome, AiOutlineUser } from 'react-icons/ai'
import { BsJournalBookmark } from 'react-icons/bs'
import { RiCustomerService2Line } from 'react-icons/ri'
import { TiContacts } from 'react-icons/ti'

const Nav = () => {
  const [activeNav, setActiveNav] = useState('#home')

  useEffect(() => {
    const sections = document.querySelectorAll('section, header')

    const handleScroll = () => {
      let current = ''

      sections.forEach(section => {
        const sectionTop = section.offsetTop - 200
        const sectionHeight = section.offsetHeight

        if (window.scrollY >= sectionTop) {
          current = section.getAttribute('id')
        }
      })

      if (current) {
        setActiveNav(`#${current}`)
      }

      // Special fix for bottom of page (contact section)
      if (
        window.innerHeight + window.scrollY >=
        document.body.offsetHeight - 5
      ) {
        setActiveNav('#contact')
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <nav>
      <a href='#home' className={activeNav === '#home' ? 'active' : ''}>
        <AiOutlineHome />
      </a>
      <a href='#about' className={activeNav === '#about' ? 'active' : ''}>
        <AiOutlineUser />
      </a>
      <a href='#experience' className={activeNav === '#experience' ? 'active' : ''}>
        <BsJournalBookmark />
      </a>
      <a href='#portfolio' className={activeNav === '#portfolio' ? 'active' : ''}>
        <RiCustomerService2Line />
      </a>
      <a href='#contact' className={activeNav === '#contact' ? 'active' : ''}>
        <TiContacts />
      </a>
    </nav>
  )
}

export default Nav